import { Brain, Database, Download } from 'lucide-react';

const features = [
  {
    icon: Brain,
    title: 'AI-Powered Discovery',
    description: 'Machine learning algorithms analyze your ideal customer profile and find matching leads across the web.',
    color: 'text-blue-400',
  },
  {
    icon: Database,
    title: 'Smart Data Enrichment',
    description: 'Real-time data enrichment adds verified contact info, company details, and social profiles to every lead.',
    color: 'text-purple-400',
  },
  {
    icon: Download,
    title: 'Lead Export',
    description: 'Export your leads to CSV or Excel format for use anywhere, anytime.',
    color: 'text-pink-400',
  },
];

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 landing-gradient-text">
            Powerful Features
          </h2>
          <p className="landing-text-muted max-w-xl mx-auto">
            Everything you need to supercharge your lead generation pipeline
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="landing-glass rounded-3xl p-8 landing-card-hover"
            >
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${feature.color} bg-white/5`}>
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white">
                {feature.title}
              </h3>
              <p className="landing-text-muted text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
